import { Collapse } from '@mui/material'
import { Alert, AlertProps } from 'components/core-v2/atoms'

export interface Props extends Omit<AlertProps, 'type'> {
  collapseClassName?: string
  isShowing: boolean
}

export const FormError = ({
  children,
  className,
  collapseClassName = '',
  isShowing,
  title
}: Props) => (
  <Collapse aria-hidden={!isShowing} className={collapseClassName} in={isShowing}>
    <Alert className={className} title={title} type="error">
      {children}
    </Alert>
  </Collapse>
)
